'use strict';
import ClassNames from 'classnames';
import ControlGroup from './control-group.jsx';
import ObjectAssign from 'object-assign';
import React from 'react';
import PropTypes from 'prop-types';


const propTypes = {
    id: PropTypes.string,
    disabled: PropTypes.bool,
    hasError: PropTypes.bool,
    help: PropTypes.string,
    inputClasses: PropTypes.object,
    label: PropTypes.string,
    name: PropTypes.string,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    rows: PropTypes.string,
    value: PropTypes.string,
    labelClasses: PropTypes.object,
    maxLength: PropTypes.number,
    autoHeight: PropTypes.bool,
    delaySaveTimeInMS: PropTypes.number
};


class TextareaControl extends React.Component {
    constructor(props) {
        super(props);

        this.onInput = this.props.autoHeight
            ? () => {
                const el = document.getElementById(this.props.id)
                el.style.height = el.scrollHeight + 'px';
            }
            : null
    }

    componentDidMount() {
        if (this.props.autoHeight) {
            const el = document.getElementById(this.props.id)
            el.style.height = el.scrollHeight + 'px';
            el.style.resize = 'none';
            el.style.overflowY = 'hidden';
        }
    }

    focus() {

        return this.input.focus();
    }

    value() {

        return this.input.value;
    }

    onKeyDown(event) {
        const { delaySaveTimeInMS, onChange } = this.props;
        if (!delaySaveTimeInMS) return;

        if (this.onChangeTimeout) {
            clearTimeout(this.onChangeTimeout);
        }

        // Prevent react from resetting its properties
        event.persist();

        this.onChangeTimeout = setTimeout(() => onChange(event, false), delaySaveTimeInMS);      
    }

    render() {
        const { maxLength, value } = this.props;

        let remainingCharacters = maxLength;
        if (typeof maxLength !== 'undefined') {
            remainingCharacters = value.length >= maxLength ? 0 : maxLength - value.length;
        }

        const inputClasses = ClassNames(ObjectAssign({
            'form-control': true,
            'form-control-field': true,
            'has-value': this.props.value && this.props.value !== ''
        }, this.props.inputClasses));

        return (
            <ControlGroup
                hasError={this.props.hasError}
                label={this.props.label}
                help={this.props.help}
                labelClasses={this.props.labelClasses}
                hideLabel={this.props.hideLabel || false}
            >
                { maxLength && (
                     <label className='text-muted' 
                         style={{ fontSize: 12, opacity: .8, position: 'absolute', top: -20, right: 0 }}
                    >{remainingCharacters} remaining characters</label>
                )}
                <textarea
                    ref={(c) => (this.input = c)}
                    className={inputClasses}
                    id={this.props.id}
                    name={this.props.name}
                    rows={this.props.rows}
                    placeholder={this.props.placeholder}
                    value={value}
                    disabled={this.props.disabled ? 'disabled' : undefined}
                    // onChange={this.props.onChange}

                    onChange={(event) => {
                        if (typeof this.props.onChange === 'function') {
                            this.props.onChange(event, undefined, !!this.props.delaySaveTimeInMS);
                        }                        
                    }} // added undefined for LinkState because it's expected second parameter to be undefined event
                    onKeyDown={this.onKeyDown.bind(this)}
                    maxLength={maxLength}
                    onInput={this.onInput}
                />
                
            </ControlGroup>
        );
    }
}

TextareaControl.propTypes = propTypes;


export default TextareaControl;
